document.addEventListener('DOMContentLoaded', () => {
const beforeImg = document.querySelector(".product-patch-compare-after-img-desktop");
const afterImg = document.querySelector(".product-patch-compare-before-img-desktop");

// Left list → updates after image
document.querySelectorAll(".product-patch-compare-left-list-desktop .product-patch-compare-item").forEach(item => {
  item.addEventListener("click", function () {
    // Remove .active from all left items
    document.querySelectorAll(".product-patch-compare-left-list-desktop .product-patch-compare-item").forEach(el => el.classList.remove("active"));
    this.classList.add("active");

    const newSrc = this.getAttribute("data-src");
    if (afterImg && newSrc) {
      afterImg.src = newSrc;
    }
  });
});

// Right list → updates before image
document.querySelectorAll(".product-patch-compare-right-list-desktop .product-patch-compare-item").forEach(item => {
  item.addEventListener("click", function () {
    // Remove .active from all right items
    document.querySelectorAll(".product-patch-compare-right-list-desktop .product-patch-compare-item").forEach(el => el.classList.remove("active"));
    this.classList.add("active");

    const newSrc = this.getAttribute("data-src");
    if (beforeImg && newSrc) {
      beforeImg.src = newSrc;
    }
  });
});

let observerLanding = new MutationObserver(checkForElementLanding);
const configLanding = { childList: true, subtree: true };
observerLanding.observe(document.body, configLanding);
function checkForElementLanding() {
  let element = document.getElementById('block__landing-results-slider-desktop');
  if (element) {
    observerLanding.disconnect(); 
    LandingImgAfterBefore();
  }
} 

function LandingImgAfterBefore (){
  const slider = document.getElementById("block__landing-results-slider-desktop");
    slider.addEventListener("input", function () {
    const frontImage = document.querySelector(".block__product-patch-compare-before-img-desktop");
    frontImage.style.clipPath = `polygon(0 0, ${this.value}% 0, ${this.value}% 100%, 0% 100%)`;
    $(".block__product-patch-compare-img-button-desktop").css("left", this.value + "%");
  });
}

if ($(".block__product-patch-compare-img").length) {
  function initComparisons() {
    var x, i;
    x = document.getElementsByClassName("block__product-patch-compare-after-img-desktop");
    let y = document.querySelector(".block__product-patch-compare-before-img-desktop");
    for (i = 0; i < x.length; i++) {
      compareImages(x[i]);
    }
    function compareImages(img) {
      var slider, img, clicked = 0, w, h;
      w = img.offsetWidth;
      h = img.offsetHeight;
      $(window).resize(function () {
        w = y.offsetWidth;
        h = y.offsetHeight;
      })
      img.style.width = (w / 2) + "px";
      var slider = document.querySelector('.block__product-patch-compare-img-button-desktop');
      // slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
      slider.addEventListener("mousedown", slideReady);
      window.addEventListener("mouseup", slideFinish);
      slider.addEventListener("touchstart", slideReady);
      window.addEventListener("touchend", slideFinish);
      function slideReady(e) {
        e.preventDefault();
        clicked = 1;
        window.addEventListener("mousemove", slideMove);
        window.addEventListener("touchmove", slideMove);
      }
      function slideFinish() {
        clicked = 0;
      }
      function slideMove(e) {
        var pos;
        if (clicked == 0) return false;
        pos = getCursorPos(e)
        if (pos < 0) pos = 0;
        if (pos > w) pos = w;
        slide(pos);
      }
      function getCursorPos(e) {
        var a, x = 0;
        e = (e.changedTouches) ? e.changedTouches[0] : e;
        a = img.getBoundingClientRect();
        x = e.pageX - a.left;
        x = x - window.pageXOffset;
        return x;
      }
      function slide(x) {
        img.style.width = x + "px";
        slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
      }
    }
  }
  initComparisons();
}
});